import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AiScreeningService } from '../../services/ai-screening.service';
import { AIScreeningService } from '../../../recruitment/services/ai-Screening';
import { DEFAULT_INTERVIEW_LANGUAGE, InterviewLanguage, joinLanguageNames } from '@edtech-ui/constants/interview-language.constant';
import { CreateScreeningRoundPayload } from '../../../models/ai-screening.model';
import { Job, Candidate } from '../../services/recruiter-data.service';
import { AddAssessmentModalComponent } from '../add-assessment-modal/add-assessment-modal.component';
import { RecruitmentJobService } from '@edtech-ui/core/services/recruitment-management/recruitment-job.service';
import { catchError, debounceTime, distinctUntilChanged, finalize, of, Subject, Subscription, tap } from 'rxjs';
import { AssignedAssessment, AssignedInterview, JobDetailApiResponse, JobDetailStats } from '@edtech-ui/core/models/recruitment/get-job-by-id';
import { JOB_PERKS_OPTIONS } from '@edtech-ui/core/constants/recuritment-constants/job-pearks-options.constants';
import { JOB_YEAR_OF_PASSING_OPTIONS } from '@edtech-ui/core/constants/recuritment-constants/job-passing-year.constants';
import { JOB_EDUCATION_OPTIONS } from '@edtech-ui/core/constants/recuritment-constants/job-educations.constants';
import { ToastrService } from 'ngx-toastr';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ActiveBeExpertDialogBoxComponent } from '../active-be-expert-dialog-box/active-be-expert-dialog-box.component';
import { QuizManagementService } from '@edtech-ui/core/services/quiz-management/quiz-management.service';
import { environment } from 'environments/environment';
import { DeleteDialogBoxComponent } from '@edtech-ui/dashboard/teacher/classroom/delete-dialog-box/delete-dialog-box.component';
import { PublishWithLinkDialogBoxComponent } from '../../../../admin-student-platform/admin-quiz-creation/publish-with-link-dialog-box/publish-with-link-dialog-box.component';
import { CourseStatusEnum } from '@edtech-ui/constants/course-status.enum';
import { ChangeQuizStatusPayload } from '@edtech-ui/core/models/quiz-review-interface.ts/quiz-status';
import { AdminCourseModeStatus, QUIZ_TYPE_LABEL_MAP } from '@edtech-ui/constants/admin-course-mode';
import { CandidateApiService } from '../../services/candidate-api.service';
import { CompanyPublishPayload } from '@edtech-ui/core/models/company-management/company-approval-status';
import { GetAllQuizResponse } from '@edtech-ui/core/models/quiz-review-interface.ts/get-all-quiz';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HasPermissionDirective } from '@edtech-ui/access-role-permissions/users-permissions-directives/has-permissions.directives';
import { PermissionForStudents } from '@edtech-ui/access-role-permissions/users-permissions-constants/student-roles-permissions.enum';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { DeepLinkUtil } from '@edtech-ui/core/utils/deep-link.util';

const EDUCATOR_DEFAULT_QUESTIONS = `Please introduce yourself briefly, including your subject expertise and teaching background.
How many years of teaching experience do you have?
Please describe your academic qualifications and mention the institutes or organizations where you have previously worked.
What is the best rank, score, selection, or academic result achieved by a student under your guidance?
For how long did that student study with you?
What specific efforts, teaching strategies, or mentoring methods did you use to help that student achieve a strong result? Also explain how your approach for a top-performing student differs from your approach for an average student.
Which learner segment are you most comfortable teaching? Please choose one or more and explain your comfort level: IIT JEE / NEET / Foundation
From your subject, choose any two topics and explain the relationship, comparison, or connection between them.
What are your three strongest topics or areas in your subject? Briefly explain why you consider them your strengths.
Please teach any two topics from your subject as if you are explaining them in a live classroom session.
The AI interviewer will ask you one conceptual question from your subject. Please answer the question and explain the concept in detail, as you would explain it to students.
The AI interviewer will ask you two additional conceptual questions from your subject. These questions will be from topics other than the three strongest topics you selected earlier. Please answer both questions and explain the concepts clearly.
How would you manage a classroom where students have different learning levels, strengths, and understanding capacities?
If you are given a target to produce top ranks or strong results, what additional efforts, systems, or strategies would you implement?`;

@Component({
	selector: 'app-job-detail',
	standalone: true,
	imports: [CommonModule, RouterModule, FormsModule, AddAssessmentModalComponent, MatProgressSpinnerModule, MatTooltipModule,
		MatDialogModule, HasPermissionDirective
	],
	templateUrl: './job-detail.component.html',
	styleUrls: ['./job-detail.component.scss']
})
export class JobDetailComponent implements OnInit, OnDestroy {

	job?: Job;
	activeSubTab: 'details' | 'assessment' | 'interview' | 'candidates' = 'details';
	candidateExperienceFilter: 'fresher' | 'experienced' | 'educator' = 'educator';
	isEditMode: boolean = false;
	showAddAssessmentModal = false;
	showAddInterviewModal = false;
	jobDetails: JobDetailApiResponse | null = null;
	isLoading = false;
	isAuthenticated = false;
	showStickyHeader = false;
	scrollListener: any;

	interviews: any[] = [];
	jobId!: string;
	companyId!: string;
	isLoadingInterviews: boolean = false;
	editForm: any = {};
	assessments: any[] = [];
	assessmentCurrentPage: number = 1;
	assessmentTotalPages: number = 1;
	assessmentHasNextPage: boolean = false;
	assessmentHasPreviousPage: boolean = false;
	assessmentLimit: number = 6;
	isClosingJob = false;
	selectedRole: string = 'null';
	isCustomRole: boolean = false;
	selectedDept: string = '';
	isCustomDept: boolean = false;
	isCreatingInterview: boolean = false;
	skillsString: string = '';

	showRoundDetailsModal: boolean = false;
	selectedRoundDetails: any = null;
	isLoadingRoundDetails: boolean = false;

	availableDepartments: string[] = [];
	availableRoles: string[] = [];

	interviewCurrentPage: number = 1;
	interviewTotalPages: number = 1;
	interviewHasNextPage: boolean = false;
	interviewHasPreviousPage: boolean = false;
	interviewLimit: number = 6;

	newInterviewForm: CreateScreeningRoundPayload = {
		job_role: '',
		department: '',

		job_description: '',
		experience: '',
		skills: [],
		passing_score: 0,
		total_duration_minutes: 0,
		valid_until: '',
		status: 'active',
		company_name: '',
		about_company: '',
		company_logo_url: '',
		application_process: '',
		is_teacher_role: false,
		is_custom_report: false,
		questions: '',
		company_id: 0,
		job_id: 0,
		maximum_attempts: 1,
		enable_multilanguage: false
	};

	basicDetails = {
		category: 'Engineering',
		workMode: 'Onsite',
		status: 'Active'
	};
	is_visible_on_bexpert = true;

	allEducationOptions = JOB_EDUCATION_OPTIONS;
	allYearPassingOptions = JOB_YEAR_OF_PASSING_OPTIONS;
	allPerksOptions = JOB_PERKS_OPTIONS;
	jobCandidates: Candidate[] = [];
	JobDetailStats: JobDetailStats | null = null;
	allCandidates: any[] = [];
	candidateTab = '';
	selectedCandidateStatus = '';
	candidateSearchQuery = '';
	selectedSkill = '';
	selectedSubject = '';
	page = 1;
	limit = 15;
	selectedJobId = '';
	assignAssessments: AssignedAssessment[] = [];
	assignInterviews: AssignedInterview[] = [];

	private readonly statusMap: Record<string, string> = {
		new: 'applied',
		applied: 'applied',
		assessment_pending: 'applied',
		assessment_completed: 'applied',
		ai_interview_pending: 'interview',
		interview_scheduled: 'interview',
		shortlisted: 'success',
		selected: 'success',
		hired: 'success',
		rejected: 'rejected',
		mock_done: 'applied',
		ai_done: 'applied',
	};


	currentPage = 1;
	totalPages = 1;
	totalCandidates = 0;
	hasNextPage = false;
	hasPreviousPage = false;
	private lastSearchQuery = '';
	private searchSubject = new Subject<string>();
	minDate: string = '';
	isSubmitDraftJob: boolean = false;
	screeningMethod: string = '';
	activeAssessmentTab: string = 'all assessment';
	activeInterviewTab: string = 'all interview';
	showAssessmentPopup = false;
	selectedAssessmentId: string | null = null;
	showAssessmentSelector = false;
	isAssessmentExpanded = true;
	isAssessmentOpen = true;
	showVisibilityPopup = false;
	assessmentPage: number = 1;
	assessmentTotalsPages = 1;
	isAssessmentLinked = false;
	isLoadingLinks = false
	isLoadingAssessments = false;
	availableAssessments: any[] = [];
	availableLinks: any[] = []
	assessmentPageSize = 4;
	linkCurrentPage = 1;
	linkTotalPages = 1;
	selectedQuizId = '';
	isAssignAssessment: boolean = false;
	isInterviewLinked = true;
	copiedId: string | null = null;
	selectedLinkId: string = '';
	subscription = new Subscription();
	isinterviewExpanded = true;
	showInterviewPopup = false;
	iaLoadingInterview = false;
	availableJobs: any[] = [];
	availableRounds: any[] = [];
	selectedInterviewId: string | null = null;
	selectedRoundId: string | null = null;
	isLoadingInterview = false;
	isAssignInterviews = false;
	aiInterviewCurrentPage = 1;
	aiInterviewLimit = 5;
	aiInterviewTotalPages = 1;
	isLoadingJobs = false;
	jobCurrentPage = 1
	jobLimit = 5
	jobTotalPages: number = 0;
	isLoadingRounds = false;
	aiInterviewHasNextPage: boolean = false;
	aiInterviewHasPreviousPage: boolean = false;
	assignInterviewCurrentPage: number = 1;
	assignInterviewLimit: number = 6;
	PermissionForStudents = PermissionForStudents;
	canViewFresher = false;
	canViewExperienced = false;
	canViewEducator = false;


	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastrService,
		private aiScreeningService: AiScreeningService,
		private jobService: RecruitmentJobService,
		private quizService: QuizManagementService,
		private dialog: MatDialog,
		private candidateService: CandidateApiService,
		private titleService: Title,
		private metaService: Meta,
		private _authService: AuthServiceService,
		private interviewLanguageService: AIScreeningService
	) { }

	/** Shown in the multi-language toggle help text; loaded from the backend language config. */
	supportedLanguageNames = DEFAULT_INTERVIEW_LANGUAGE.name;

	private loadSupportedInterviewLanguages(): void {
		this.interviewLanguageService.getLanguages().subscribe({
			next: (res: any) => {
				const languages: InterviewLanguage[] = res?.Data || res?.data || [];
				const names = languages.filter(lang => lang.accept_as_input !== false && !lang.is_mixed).map(lang => lang.name);
				if (names.length) this.supportedLanguageNames = joinLanguageNames(names, 'and');
			},
			error: (err: any) => console.warn('Failed to load interview languages:', err)
		});
	}


	ngOnInit(): void {
		this.loadSupportedInterviewLanguages();
		const token = localStorage.getItem('token');
		const companyId = localStorage.getItem('company_id');

		this.canViewFresher = this._authService.hasPermission(PermissionForStudents.CANDIDATE_VIEW_FRESHER);
		this.canViewExperienced = this._authService.hasPermission(PermissionForStudents.CANDIDATE_VIEW_EXPERIENCED);
		this.canViewEducator = this._authService.hasPermission(PermissionForStudents.CANDIDATE_VIEW_EDUCATOR);

		if (this.canViewFresher) {
			this.candidateTab = 'fresher';
		} else if (this.canViewExperienced) {
			this.candidateTab = 'experienced';
		} else if (this.canViewEducator) {
			this.candidateTab = 'educator';
		}

		this.isAuthenticated = !!(token && companyId);
		if (!this.isAuthenticated) {
			this.scrollListener = (event: any) => {
				const target = event.target;
				if (target && target.scrollTop !== undefined) {
					this.showStickyHeader = target.scrollTop > 180;
				} else {
					const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
					this.showStickyHeader = scrollTop > 180;
				}
			};
			window.addEventListener('scroll', this.scrollListener, true);
		}
		const tomorrow = new Date();
		tomorrow.setDate(tomorrow.getDate() + 1);
		this.minDate = tomorrow.toISOString().split('T')[0];

		this.jobId = this.route.snapshot.paramMap.get('id') || '';
		this.companyId = localStorage.getItem('company_id') || '';

		if (this.jobId) {
			localStorage.setItem('job_id', this.jobId);
		}


		if (this.jobId) {
			this.getCompanyJobDetails();
		}



		if (this.isAuthenticated) {
			this.fetchInterviews();
			this.fetchAssessments();
		}
		this.route.queryParams.subscribe(params => {
			const tab = params['subTab'];
			const innerTab = params['innerTab'];
			if (tab === 'details' || tab === 'assessment' || tab === 'interview' || tab === 'candidates') {
				this.activeSubTab = tab;
				if (tab === 'interview') {
					if (innerTab === 'assign') {
						this.activeInterviewTab = 'assign interview';
					} else {
						this.activeInterviewTab = 'all interview';
					}
				}
			}
		});
		this.searchSubject.pipe(debounceTime(500), distinctUntilChanged()).subscribe(() => {
			if (this.isAuthenticated) {
				this.loadCandidates();
			}
		});
		if (this.isAuthenticated) {
			this.loadCandidates();
		}
	}

	redirectToHome() {
		const path = `job/${this.jobId}`;
		if (DeepLinkUtil.isAndroid()) {
			window.location.href = DeepLinkUtil.getAndroidIntentUrl(path);
		} else {
			this.router.navigate(['/login'], { queryParams: { redirectUrl: '/student-dashboard/jobs-detail-page/' + this.jobId } });
		}
	}

	get paginatedAssignInterviews() {
		const start = (this.assignInterviewCurrentPage - 1) * this.assignInterviewLimit;
		return this.assignInterviews.slice(start, start + this.assignInterviewLimit);
	}

	get assignInterviewTotalPages() {
		return Math.ceil(this.assignInterviews.length / this.assignInterviewLimit) || 1;
	}

	get assignInterviewHasNextPage() {
		return this.assignInterviewCurrentPage < this.assignInterviewTotalPages;
	}

	get assignInterviewHasPreviousPage() {
		return this.assignInterviewCurrentPage > 1;
	}

	onAssignInterviewPageChange(page: number) {
		if (page >= 1 && page <= this.assignInterviewTotalPages) {
			this.assignInterviewCurrentPage = page;
		}
	}

	assignAssessmentCurrentPage: number = 1;
	assignAssessmentLimit: number = 6;

	get paginatedAssignAssessments() {
		const start = (this.assignAssessmentCurrentPage - 1) * this.assignAssessmentLimit;
		return this.assignAssessments.slice(start, start + this.assignAssessmentLimit);
	}

	get assignAssessmentTotalPages() {
		return Math.ceil(this.assignAssessments.length / this.assignAssessmentLimit) || 1;
	}

	get assignAssessmentHasNextPage() {
		return this.assignAssessmentCurrentPage < this.assignAssessmentTotalPages;
	}

	get assignAssessmentHasPreviousPage() {
		return this.assignAssessmentCurrentPage > 1;
	}

	onAssignAssessmentPageChange(page: number) {
		if (page >= 1 && page <= this.assignAssessmentTotalPages) {
			this.assignAssessmentCurrentPage = page;
		}
	}


	getStatusLabel(status: string): string {
		return this.statusMap[status] || status;
	}


	switchCandidateTab(tab: 'fresher' | 'experienced' | 'educator') {

		if ((tab === 'fresher' && !this.canViewFresher) || (tab === 'experienced' && !this.canViewExperienced) || (tab === 'educator' && !this.canViewEducator)) {
			return;
		}

		this.candidateExperienceFilter = tab;
		this.candidateTab = tab;
		this.loadCandidates();
	}

	onAddAssessmentClick(): void {
		this.showAddAssessmentModal = true;
	}

	onAddInterviewClick(): void {
		this.openAddInterviewModal();
	}

	setSubTab(tab: 'details' | 'assessment' | 'interview' | 'candidates'): void {
		this.activeSubTab = tab;
		if (tab === 'interview') {
			this.activeInterviewTab = 'all interview';
			this.fetchInterviews();
		}
		if (tab === 'assessment') {
			this.activeAssessmentTab = 'all assessment'
			this.fetchAssessments();
		}
	}


	getFilteredCandidates(): Candidate[] {
		return this.jobCandidates.filter(c => c.experienceType === this.candidateExperienceFilter);
	}

	getFresherCount(): number {
		return this.jobCandidates.filter(c => c.experienceType === 'fresher').length;
	}

	getExperiencedCount(): number {
		return this.jobCandidates.filter(c => c.experienceType === 'experienced').length;
	}

	getScoreColorClass(score: number): string {
		if (score >= 85) return 'score-excellent';
		if (score >= 65) return 'score-good';
		return 'score-poor';
	}

	goBack(): void {
		this.router.navigate(['/recruiter-dashboard/jobs']);
	}

	cancelEdit(): void {
		this.isEditMode = false;
		this.editForm = {};
	}

	onSearchChange(): void {
		this.searchSubject.next(this.candidateSearchQuery);
	}

	addRequiredSkill(): void {
		if (this.editForm.newRequiredSkill.trim()) {
			this.editForm.requiredSkills.push(this.editForm.newRequiredSkill.trim());
			this.editForm.newRequiredSkill = '';
		}
	}

	removeRequiredSkill(index: number): void {
		this.editForm.requiredSkills.splice(index, 1);
	}

	addPreferredSkill(): void {
		if (this.editForm.newPreferredSkill.trim()) {
			this.editForm.preferredSkills.push(this.editForm.newPreferredSkill.trim());
			this.editForm.newPreferredSkill = '';
		}
	}

	removePreferredSkill(index: number): void {
		this.editForm.preferredSkills.splice(index, 1);
	}

	// Matrix selection toggles
	toggleEducation(edu: string): void {
		const idx = this.editForm.education.indexOf(edu);
		if (idx > -1) {
			this.editForm.education.splice(idx, 1);
		} else {
			this.editForm.education.push(edu);
		}
	}


	toggleYearPassing(year: number): void {
		const idx = this.editForm.yearPassing.indexOf(year);
		if (idx > -1) {
			this.editForm.yearPassing.splice(idx, 1);
		} else {
			this.editForm.yearPassing.push(year);
		}
	}


	togglePerk(perk: string): void {
		const idx = this.editForm.perks.indexOf(perk);
		if (idx > -1) {
			this.editForm.perks.splice(idx, 1);
		} else {
			this.editForm.perks.push(perk);
		}
	}

	checkCustomRole(): void {
		if (this.selectedRole === 'custom') {
			this.isCustomRole = true;
			this.selectedRole = '';
		}
	}


	cancelCustomRole(): void {
		this.isCustomRole = false;
		this.selectedRole = 'null';
	}


	checkCustomDept(): void {
		if (this.selectedDept === 'custom') {
			this.isCustomDept = true;
			this.selectedDept = '';
		}
	}


	cancelCustomDept(): void {
		this.isCustomDept = false;
		this.selectedDept = '';
	}

	onTeacherRoleToggle(): void {
		if (this.newInterviewForm.is_teacher_role && !this.newInterviewForm.questions?.trim()) {
			this.newInterviewForm.questions = EDUCATOR_DEFAULT_QUESTIONS;
		}
	}

	get isCreateInterviewFormValid(): boolean {
		return !!(
			this.selectedRole && this.selectedRole !== 'null' && this.selectedRole.trim() !== '' &&
			this.selectedDept && this.selectedDept !== 'null' && this.selectedDept.trim() !== '' &&
			this.newInterviewForm.experience && this.newInterviewForm.experience.trim() !== '' &&
			this.newInterviewForm.valid_until && this.newInterviewForm.valid_until.trim() !== '' &&
			this.newInterviewForm.total_duration_minutes && Number(this.newInterviewForm.total_duration_minutes) > 0 &&
			this.newInterviewForm.passing_score !== null && this.newInterviewForm.passing_score !== undefined && this.newInterviewForm.passing_score.toString().trim() !== '' &&
			this.newInterviewForm.job_description && this.newInterviewForm.job_description.trim() !== '' &&
			this.newInterviewForm.questions && this.newInterviewForm.questions.trim() !== '' &&
			this.skillsString && this.skillsString.trim() !== '' &&
			this.newInterviewForm.maximum_attempts && Number(this.newInterviewForm.maximum_attempts) >= 1 && Number(this.newInterviewForm.maximum_attempts) <= 10
		);
	}


	createInterview(): void {
		this.newInterviewForm.job_role = this.selectedRole;
		this.newInterviewForm.department = this.selectedDept;
		// Ensure job_id and company_id are set properly
		this.newInterviewForm.job_id = Number(this.jobId) || this.jobId || 0;
		this.newInterviewForm.company_id = Number(this.companyId) || this.companyId || 0;

		// Parse skills string to array
		this.newInterviewForm.skills = this.skillsString
			? this.skillsString.split(',').map(s => s.trim()).filter(s => s)
			: [];

		// Parse duration to number if needed
		this.newInterviewForm.total_duration_minutes = Number(this.newInterviewForm.total_duration_minutes) || 0;

		this.isCreatingInterview = true;
		this.aiScreeningService.createScreeningRound(this.newInterviewForm).subscribe({
			next: (response) => {
				this.isCreatingInterview = false;
				this.showAddInterviewModal = false;
				this.fetchInterviews();
				this.selectedRole = 'null';
				this.selectedDept = '';
				this.isCustomRole = false;
				this.isCustomDept = false;
				this.newInterviewForm.questions = '';
				this.newInterviewForm.job_description = '';
				this.newInterviewForm.skills = [];
				this.skillsString = '';
			},
			error: (err) => {
				this.isCreatingInterview = false;
				console.error('Failed to create interview round', err);
				this.toastr.error('Failed to create screening round. Please try again.');
			}
		});
	}

	openAddInterviewModal(): void {
		this.showAddInterviewModal = true;
		this.isCustomRole = false;
		this.isCustomDept = false;
		this.skillsString = '';

		this.newInterviewForm = {
			job_role: '',
			department: '',
			job_description: '',
			experience: '',
			skills: [],
			passing_score: 0,
			total_duration_minutes: 0,
			valid_until: '',
			status: 'active',
			company_name: '',
			about_company: '',
			company_logo_url: '',
			application_process: '',
			is_teacher_role: false,
			is_custom_report: false,
			questions: '',
			company_id: Number(this.companyId) || 0,
			job_id: Number(this.jobId) || 0,
			maximum_attempts: 1,
			enable_multilanguage: false
		};

		const details = this.jobDetails;
		if (details) {
			if (details.job_title) {
				const role = details.job_title;
				if (!this.availableRoles.includes(role)) {
					this.availableRoles.push(role);
				}
				this.selectedRole = role;
			} else {
				this.selectedRole = 'null';
			}

			if (details.job_role_category) {
				const dept = details.job_role_category;
				if (!this.availableDepartments.includes(dept)) {
					this.availableDepartments.push(dept);
				}
				this.selectedDept = dept;
			} else {
				this.selectedDept = '';
			}

			if (details.experience_level) {
				const exp = details.experience_level.toLowerCase().trim();
				if (exp.includes('fresher') || exp.includes('0-1')) {
					this.newInterviewForm.experience = 'Fresher';
				} else if (exp.includes('1-3')) {
					this.newInterviewForm.experience = '1-3 Years';
				} else if (exp.includes('3+') || exp.includes('3-5') || exp.includes('3-5 years') || exp.includes('3 years') || exp.includes('5 years')) {
					this.newInterviewForm.experience = '3-5 Years';
				} else {
					this.newInterviewForm.experience = 'Fresher';
				}
			} else {
				this.newInterviewForm.experience = '';
			}

			if (details.description) {
				this.newInterviewForm.job_description = details.description;
			} else {
				this.newInterviewForm.job_description = '';
			}

			if (details.required_skills && details.required_skills.length > 0) {
				this.skillsString = details.required_skills.join(', ');
			} else {
				this.skillsString = '';
			}
		}
	}

	fetchInterviews(): void {
		this.isLoadingInterviews = true;
		const params: any = { page: this.interviewCurrentPage, limit: this.interviewLimit };
		if (this.jobId) params.job_id = this.jobId;
		if (this.companyId) params.company_id = this.companyId;

		this.aiScreeningService.getRounds(params).subscribe({
			next: (response) => {
				this.isLoadingInterviews = false;
				if (response && response.Success && response.Data) {
					this.interviews = response.Data.rounds || [];
					if (response.Data.pagination) {
						this.interviewCurrentPage = response.Data.pagination.current_page;
						this.interviewTotalPages = response.Data.pagination.last_page;
						this.interviewHasNextPage = this.interviewCurrentPage < this.interviewTotalPages;
						this.interviewHasPreviousPage = this.interviewCurrentPage > 1;
					}
				}
			},
			error: (err) => {
				this.isLoadingInterviews = false;
				console.error('Failed to load interviews', err);
			}
		});
	}

	isInterviewExpired(interview: any): boolean {
		if (interview.is_valid === false) return true;
		if (interview.status?.toLowerCase().includes('expire')) return true;
		if (interview.valid_until) {
			return new Date() > new Date(interview.valid_until);
		}
		return false;
	}

	isAssignInterviewExpired(assignInterview: AssignedInterview): boolean {
		const fullInterview = this.interviews.find((i: any) => i.id === assignInterview.screening_round_id);
		if (fullInterview) {
			return this.isInterviewExpired(fullInterview);
		}
		if (assignInterview.status?.toLowerCase().includes('expire')) return true;
		return false;
	}

	onInterviewPageChange(newPage: number): void {
		if (newPage >= 1 && newPage <= this.interviewTotalPages) {
			this.interviewCurrentPage = newPage;
			this.fetchInterviews();
		}
	}

	onViewRoundDetails(roundId: string | number): void {
		if (this.jobId && roundId) {
			const innerTab = this.activeInterviewTab === 'assign interview' ? 'assign' : 'all';
			this.router.navigate(['/recruiter-dashboard/jobs', this.jobId, 'rounds', roundId], { queryParams: { from: innerTab } });
		}
	}

	closeRoundDetailsModal(): void {
		this.showRoundDetailsModal = false;
		this.selectedRoundDetails = null;
	}

	copyRoundLink(link: string): void {
		if (link) {
			navigator.clipboard.writeText(link).then(() => {
				this.toastr.success('Link copied to clipboard!');
			}).catch(err => {
				console.error('Could not copy text: ', err);
			});
		}
	}

	viewCandidateReport(candidate: any): void {
		if (candidate.report_link) {
			window.open(candidate.report_link, '_blank');
			return;
		}

		const sessionId = candidate.interview_session_id || candidate.front_end_session_id || candidate.session_id || candidate.id;
		const candidateId = candidate.candidate_id || candidate.id;


		let token = candidate.token;
		if (!token && this.selectedRoundDetails && this.selectedRoundDetails.screening_access_link) {
			const parts = this.selectedRoundDetails.screening_access_link.split('/');
			token = parts[parts.length - 2];
		}
		if (!token) token = 'none';

		if (sessionId && candidateId) {
			this.router.navigate(['/ai-performance-report', candidateId, sessionId, token]);
		} else {
			this.toastr.info('Report not available yet.');
		}
	}

	fetchAssessments(): void {
		const targetClassroomId = environment.classroomId;
		this.quizService.getAllQuizes(targetClassroomId, this.assessmentCurrentPage, this.assessmentLimit, '', 'created_at', 'desc', CourseStatusEnum.All, this.companyId, this.jobId).pipe(
			tap(response => {
				if (response.Success) {
					let allAssessments = response.Data.data || [];
					if (this.companyId && this.jobId) {
						allAssessments = allAssessments.filter((quiz: any) =>
							(quiz.company_id === this.companyId && quiz.job_id === this.jobId) ||
							(quiz.company_id === undefined && quiz.job_id === undefined)
						);
					}
					this.assessments = allAssessments;

					if (response.Data.pagination) {
						this.assessmentTotalPages = response.Data.pagination.totalPages;
						this.assessmentHasNextPage = response.Data.pagination.hasNextPage;
						this.assessmentHasPreviousPage = response.Data.pagination.hasPreviousPage;
					}
				}
			}),
			catchError(err => {
				console.error('Failed to load assessments', err);
				return of(null);
			})
		).subscribe();
	}

	nextAssessmentPage(): void {
		if (this.assessmentHasNextPage) {
			this.assessmentCurrentPage++;
			this.fetchAssessments();
		}
	}

	previousAssessmentPage(): void {
		if (this.assessmentHasPreviousPage) {
			this.assessmentCurrentPage--;
			this.fetchAssessments();
		}
	}

	openMenuId: string | null = null;

	toggleMenu(quizId: string): void {
		this.openMenuId = this.openMenuId === quizId ? null : quizId;
	}

	onEditQuiz(quiz: any): void {
		this.openMenuId = null;
		this.router.navigate(['/admin-student-platform/create-quiz', environment.classroomId, quiz.quiz_id]);
	}

	onViewQuiz(quizId: string): void {
		this.router.navigate(['/admin-student-platform/admin-quiz-management', environment.classroomId, quizId]);
	}

	onDeleteQuiz(quiz: any): void {
		this.openMenuId = null;
		this.openDeleteQuizDialogBox(quiz.quiz_id);
	}

	openDeleteQuizDialogBox(quizId: string): void {
		this.dialog.open(DeleteDialogBoxComponent, {
			width: '360px',
			data: { quizId }
		}).afterClosed().subscribe(result => {
			if (result) {
				this.deleteQuizById(quizId);
			}
		});
	}

	deleteQuizById(quizId: string): void {
		this.quizService.deleteQuizById(quizId).subscribe({
			next: (res: any) => {
				if (res?.Success) {
					this.toastr.success('Assessment deleted successfully');
					this.fetchAssessments();
				} else {
					this.toastr.error(res?.Message || 'Failed to delete assessment');
				}
			},
			error: () => {
				this.toastr.error('Server error while deleting assessment');
			}
		});
	}

	goToGenerativeDetailPage(quizId: string) {
		this.router.navigate(['/admin-student-platform/view-links', quizId]);
	}

	openGenerateLinkDialogBox(quizId: string) {
		const dialogRef = this.dialog.open(PublishWithLinkDialogBoxComponent, {
			data: { quizId: quizId }
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result === true) {
				this.fetchAssessments();
			}
		});
	}

	changeQuizStatus(quizId: string) {
		const payload: ChangeQuizStatusPayload = {
			quiz_id: quizId,
			target_status: CourseStatusEnum.Published
		}
		this.quizService.putChangeQuizStatus(payload).pipe(
			tap(response => {
				if (response.Success) {
					this.toastr.success('Your assessment has been published and is now available!');
					this.openGenerateLinkDialogBox(quizId)
				} else {
					this.toastr.error(response.Message);
				}
			}),
			catchError(() => {
				this.toastr.error('Something went wrong. Please try again.');
				return of(null);
			})
		).subscribe();
	}

	getQuizTypeLabel(type: string): string {
		return QUIZ_TYPE_LABEL_MAP[type as AdminCourseModeStatus] || type;
	}

	truncateText(text: string, limit: number = 100): string {
		if (!text) return '';
		return text.length > limit ? text.substring(0, limit) + '...' : text;
	}

	@HostListener('document:click', ['$event'])
	handleDocumentClick(event: MouseEvent): void {
		this.openMenuId = null;
	}


	getCompanyJobDetails() {
		this.isLoading = true;
		const request = this.companyId
			? this.jobService.getJobPostById(this.jobId, this.companyId)
			: this.jobService.getPublicJobPostById(this.jobId);

		this.subscription.add(
			request.pipe(
				tap(response => {
					if (response.Success) {
						this.jobDetails = response.Data;
						this.JobDetailStats = response.Data.stats || null;
						this.is_visible_on_bexpert = response.Data.is_visible_on_student_dashboard;
						this.assignAssessments = response.Data.assigned_assessments || [];
						this.assignInterviews = response.Data.assigned_interviews || [];

						// SEO Optimization for Public Viewers
						if (!this.isAuthenticated) {
							const jobTitle = this.jobDetails?.job_title || 'Job';
							const companyName = this.jobDetails?.company_name || 'Company';
							const locations = this.jobDetails?.locations?.join(', ') || 'Remote';

							const pageTitle = `${jobTitle} at ${companyName} | BeExpert.ai`;
							const pageDesc = `Apply for ${jobTitle} at ${companyName} in ${locations}. Join BeExpert.ai to prepare, apply, and get hired.`;

							this.titleService.setTitle(pageTitle);
							this.metaService.updateTag({ name: 'description', content: pageDesc });
							this.metaService.updateTag({ property: 'og:title', content: pageTitle });
							this.metaService.updateTag({ property: 'og:description', content: pageDesc });
						}
					}
				}),
				finalize(() => {
					this.isLoading = false;
				}),
				catchError(() => {
					this.toastr.error('Something went wrong.Please try again');
					return of(null);
				})
			).subscribe()
		);
	}

	formatSalary(min: any, max: any, currency: string = '₹', freq: string = 'LPA'): string {
		const safeFreq = freq || 'LPA';
		const safeCurrency = currency || '₹';
		if (!min && !max) return '—';
		
		const formatSingle = (val: any) => {
			if (val === null || val === undefined || val === '') return '';
			const num = Number(val);
			if (isNaN(num)) return String(val);
			if (safeFreq === 'LPA') {
				const lpaVal = num >= 1000 ? num / 100000 : num;
				return Number(lpaVal.toFixed(2)).toString();
			}
			return `${num}`;
		};

		let displayStr = formatSingle(min);
		if (max && max !== min) {
			displayStr += ` - ${formatSingle(max)}`;
		}

		return `${safeCurrency} ${displayStr} ${safeFreq}`;
	}


	startEdit(): void {
		if (!this.jobDetails) return;
		this.isEditMode = true;

		this.editForm = {
			title: this.jobDetails.job_title,
			category: this.jobDetails.job_role_category,
			type: this.jobDetails.job_type,
			workMode: this.jobDetails.work_mode,
			location: this.jobDetails.locations?.[0] || '',
			descriptionText: this.jobDetails.description,
			rolesText: this.jobDetails.roles_and_responsibilities,
			requiredSkills: [...(this.jobDetails.required_skills || [])],
			preferredSkills: [...(this.jobDetails.preferred_skills || [])],
			education: [...(this.jobDetails.education || [])],
			minCgpa: this.jobDetails.min_cgpa,
			experience: this.jobDetails.experience_level,
			yearPassing: [...(this.jobDetails.year_of_passing || [])],
			openings: this.jobDetails.number_of_openings,
			deadline: this.jobDetails.application_deadline,
			salaryMin: this.jobDetails.salary_min,
			salaryMax: this.jobDetails.salary_max,
			currency: this.jobDetails.currency || '₹',
			payment_frequency: this.jobDetails.payment_frequency || 'LPA',
			expectedFtSalary: this.jobDetails.expected_full_time_salary,
			expected_full_time_salary_currency: this.jobDetails.expected_full_time_salary_currency || '₹',
			expected_full_time_salary_frequency: this.jobDetails.expected_full_time_salary_frequency || 'LPA',
			perks: [...(this.jobDetails.perks_and_benefits || [])],
			is_visible_on_student_dashboard: this.is_visible_on_bexpert,
			default_passing_score: this.jobDetails.default_passing_score !== undefined ? this.jobDetails.default_passing_score : 40,
		};
	}

	onEditJobTypeChange(jobType: string): void {
		if (jobType === 'Internship/Training') {
			this.editForm.payment_frequency = 'Per Month';
		} else {
			this.editForm.payment_frequency = 'LPA';
		}
	}
	saveEdit(): void {
		let salMin: string | number = this.editForm.salaryMin;
		let salMax: string | number = this.editForm.salaryMax || this.editForm.salaryMin;

		const payload: any = {
			job_title: this.editForm.title,
			job_role_category: this.editForm.category,
			job_type: this.editForm.type,
			work_mode: this.editForm.workMode,
			locations: [this.editForm.location].map(l => l?.trim()).filter(l => l),
			description: this.editForm.descriptionText,
			roles_and_responsibilities: this.editForm.rolesText,
			required_skills: this.editForm.requiredSkills,
			preferred_skills: this.editForm.preferredSkills,
			education: this.editForm.education,
			min_cgpa: this.editForm.minCgpa,
			experience_level: this.editForm.experience,
			year_of_passing: this.editForm.yearPassing,
			number_of_openings: this.editForm.openings,
			application_deadline: this.editForm.deadline,
			perks_and_benefits: this.editForm.perks,
			salary_min: salMin ? (!isNaN(Number(salMin)) ? Number(salMin) : salMin) : null,
			currency: this.editForm.currency,
			payment_frequency: this.editForm.payment_frequency,
			salary_max: salMax ? (!isNaN(Number(salMax)) ? Number(salMax) : salMax) : null,
			expected_full_time_salary: this.editForm.expectedFtSalary ? (!isNaN(Number(this.editForm.expectedFtSalary)) ? Number(this.editForm.expectedFtSalary) : this.editForm.expectedFtSalary) : null,
			expected_full_time_salary_currency: this.editForm.expected_full_time_salary_currency,
			expected_full_time_salary_frequency: this.editForm.expected_full_time_salary_frequency,
			default_passing_score: this.editForm.default_passing_score ? Number(this.editForm.default_passing_score) : 40
		};

		this.subscription.add(
			this.jobService.patchJobPosting(this.jobId, this.companyId, payload).pipe(
				tap(response => {
					if (response.Success) {
						this.jobDetails = { ...response.Data, submitted_at: response.Data.submitted_at ?? '', };
						this.getCompanyJobDetails();
						this.isEditMode = false;
					} else {
						this.toastr.error(response.Message);
					}
				})
			).subscribe()
		);
	}


	postCloseActiveJob() {
		this.isClosingJob = true;
		this.subscription.add(
			this.jobService.postCloseActiveJob(this.jobId, this.companyId).pipe(
				tap(response => {
					if (response.Success) {
						this.getCompanyJobDetails();
					} else {
						this.toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.isClosingJob = false;
				})
			).subscribe());
	}


	openVisibilityDialog() {
		const dialogRef = this.dialog.open(ActiveBeExpertDialogBoxComponent, {
			width: '500px',
			data: {
				isVisible: this.is_visible_on_bexpert
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result === undefined) return;

			const payload = {
				is_visible_on_student_dashboard: result,
				hiring_process: this.jobDetails?.hiring_process || []
			} as any;

			this.subscription.add(
				this.jobService.patchJobPosting(
					this.jobId,
					this.companyId,
					payload).pipe(
						tap(response => {
							if (response.Success) {
								this.is_visible_on_bexpert = result;
								this.toastr.success(response.Message);
								this.showVisibilityPopup = false;
							} else {
								this.toastr.error(response.Message);
							}
						})
					).subscribe());
		});
	}


	loadCandidates(): void {

		const hasPermission = (this.candidateTab === 'fresher' && this.canViewFresher) ||
			(this.candidateTab === 'experienced' && this.canViewExperienced) ||
			(this.candidateTab === 'educator' && this.canViewEducator);

		if (!hasPermission) {
			this.allCandidates = [];
			this.totalCandidates = 0;
			this.isLoading = false;
			return;
		}

		if (this.candidateSearchQuery !== this.lastSearchQuery) {
			this.currentPage = 1;
			this.lastSearchQuery = this.candidateSearchQuery;
		}

		this.isLoading = true;

		const typeMap: Record<string, string> = {
			Fresher: 'fresher',
			Experienced: 'experienced',
			Educator: 'educator'
		};

		const payload = {
			candidate_type: this.candidateTab,
			job_id: this.jobId || undefined,
			search: undefined
		}

		this.subscription.add(
			this.candidateService.listCandidates(payload).pipe(
				finalize(() => {
					this.isLoading = false;
				})
			).subscribe({
				next: (res) => {
					if (res.Success) {
						const candidates = res?.Data?.candidates || res?.data || [];
						this.screeningMethod = res.Data.screening_method;

						// Filter client-side
						let filtered = [...candidates];
						if (this.candidateSearchQuery && this.candidateSearchQuery.trim()) {
							const query = this.candidateSearchQuery.toLowerCase().trim();
							filtered = filtered.filter((c: any) => {
								const nameMatch = c.name?.toLowerCase().includes(query);
								const emailMatch = c.email?.toLowerCase().includes(query);
								const jobTitleMatch = c.job_title?.toLowerCase().includes(query);
								const mobileMatch = c.mobile?.toLowerCase().includes(query);
								const subjectMatch = c.subject?.toLowerCase().includes(query);
								const specMatch = c.subject_specialization?.toLowerCase().includes(query);
								const expMatch = String(c.experience_years)?.toLowerCase().includes(query);
								const currCtcMatch = String(c.current_ctc)?.toLowerCase().includes(query);
								const expCtcMatch = String(c.expected_ctc)?.toLowerCase().includes(query);
								const instMatch = c.previous_institute?.toLowerCase().includes(query);
								const city1Match = c.city_pref_1?.toLowerCase().includes(query);
								const city2Match = c.city_pref_2?.toLowerCase().includes(query);
								const city3Match = c.city_pref_3?.toLowerCase().includes(query);
								const statusMatch = c.status?.toLowerCase().includes(query);

								return !!(nameMatch || emailMatch || jobTitleMatch || mobileMatch || subjectMatch ||
									specMatch || expMatch || currCtcMatch || expCtcMatch || instMatch ||
									city1Match || city2Match || city3Match || statusMatch);
							});
						}

						this.totalCandidates = filtered.length;
						const startIndex = (this.currentPage - 1) * this.limit;
						const endIndex = startIndex + this.limit;
						this.allCandidates = filtered.slice(startIndex, endIndex);

						this.totalPages = Math.ceil(this.totalCandidates / this.limit) || 1;
						this.hasNextPage = this.currentPage < this.totalPages;
						this.hasPreviousPage = this.currentPage > 1;
					} else {
						this.toastr.error(res.Message);
					}
				},
				error: () => {
					this.isLoading = false;
				}
			}));
	}


	nextPage(): void {
		if (this.hasNextPage) {
			this.currentPage++;
			this.loadCandidates();
		}
	}

	previousPage(): void {
		if (this.hasPreviousPage) {
			this.currentPage--;
			this.loadCandidates();
		}
	}


	clearFilters(): void {
		this.selectedCandidateStatus = '';
		this.candidateSearchQuery = '';
		this.selectedSkill = '';
		this.selectedSubject = '';
		this.selectedJobId = '';
		this.loadCandidates();
	}


	goToDetailPage(candidateId: string): void {
		this.router.navigate(['/recruiter-dashboard/candidates', candidateId]);
	}


	getStatusClass(status: string): string {
		const normalized = status?.toLowerCase()?.trim();

		switch (normalized) {
			case 'applied':
				return 'pill-applied';

			case 'shortlisted':
			case 'interview':
				return 'pill-interview';

			case 'selected':
				return 'pill-success';

			case 'rejected':
				return 'pill-rejected';

			default:
				return 'pill-applied';
		}
	}


	downloadResume(resumeUrl: string): void {
		if (!resumeUrl) {
			return;
		}

		const link = document.createElement('a');
		link.href = resumeUrl;
		link.target = '_blank';
		link.download = '';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}


	downloadUserData() {
		this.subscription.add(
			this.candidateService.exportCandidateTemplate(this.companyId, this.candidateTab).subscribe({
				next: (blob: Blob) => {
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = 'candidates.xlsx';
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
					window.URL.revokeObjectURL(url);
					this.toastr.success('Template downloaded successfully');
				},
				error: () => {
					this.toastr.error('Failed to download template');
				}
			}));
	}


	postSubmitDraftJob() {

		const payload: CompanyPublishPayload = {
			screening_method: this.screeningMethod
		};

		this.isSubmitDraftJob = true;
		this.subscription.add(
			this.jobService.postCompanyPublish(payload, this.jobId, this.companyId).pipe(
				tap((response) => {
					if (response.Success) {
						this.toastr.success('Your job is currently pending approval. Once it is approved, we will notify you via email.');
						this.getCompanyJobDetails();
					} else {
						this.toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.isSubmitDraftJob = false;
				}),
				catchError(() => {
					this.toastr.error('Publish API failed');
					return of(null);
				})
			).subscribe());
	}


	getAllQuiz(page: number = 1): void {
		this.availableAssessments = [];
		this.isLoadingAssessments = true;

		const companyId = localStorage.getItem('company_id') ?? undefined;
		this.subscription.add(
			this.quizService.getAllQuizes(environment.classroomId, page, this.assessmentPageSize, '', 'created_at', 'desc', CourseStatusEnum.All, companyId, this.jobId).pipe(
				tap((response: GetAllQuizResponse) => {
					if (response.Success) {
						this.availableAssessments = response.Data.data;
						this.assessmentPage = response.Data.pagination!.page;
						this.assessmentTotalsPages = response.Data.pagination!.totalPages;
					} else {
						this.toastr.error(response.Message || 'Failed to load assessments');
					}
				}),
				catchError(() => {
					this.toastr.error('Failed to load assessments');
					return of(null);
				}),
				finalize(() => {
					this.isLoadingAssessments = false;
				})
			).subscribe());
	}


	openAssessmentPopup(): void {
		this.showAssessmentPopup = true;
		if (!this.isLoadingAssessments && this.availableAssessments.length === 0) {
			this.getAllQuiz();
		}
	}


	openInterviewPopup(): void {
		this.showInterviewPopup = true;
		this.selectedInterviewId = this.jobId;
		this.availableRounds = [];
		this.selectedRoundId = null;
		this.getInterviewRounds();
	}


	getDuration(timeLimit: number | null | undefined): string {
		if (!timeLimit) {
			return '—';
		}
		const minutes = timeLimit / 60;
		if (minutes >= 60) {
			const hours = Math.floor(minutes / 60);
			const remainingMinutes = minutes % 60;
			return remainingMinutes ? `${hours} hr ${remainingMinutes} min` : `${hours} hr`;
		}
		return `${minutes} min`;
	}


	getAllSelectedAssessmentLink(quizId: string, jobId: string, page: number = 1): void {
		this.jobId = jobId;
		this.subscription.add(
			this.quizService.getAllGenerateLinks(quizId, page, 10).pipe(
				tap((response) => {
					if (response.Success) {
						this.availableLinks = response.Data.data.map((link: any) => ({ ...link, job_id: jobId }));
						this.linkCurrentPage = response.Data.pagination.page;
						this.linkTotalPages = response.Data.pagination.totalPages;
					} else {
						this.toastr.error(response.Message || 'Failed to load assessment links');
					}
				}),
				catchError(() => {
					this.toastr.error('Failed to load assessment links');
					return of(null);
				}),
				finalize(() => {
					this.isLoadingLinks = false;
				})
			).subscribe());
	}


	toggleVisibilityPopup(event: Event): void {
		event.preventDefault();
		event.stopPropagation();
		this.showVisibilityPopup = true;
	}


	closePopup(): void {
		this.showVisibilityPopup = false;
	}


	onAssessmentSelected(assessment: any): void {
		this.selectedAssessmentId = assessment.quiz_id;
		this.selectedQuizId = assessment.quiz_id;
		this.availableLinks = [];
		this.selectedLinkId = '';
		this.getAllSelectedAssessmentLink(assessment.quiz_id, this.jobId);
	}


	onInterviewSelected(job: any): void {
		this.selectedInterviewId = job.job_id;
		this.availableRounds = [];
		this.selectedRoundId = null;
		this.getInterviewRounds();
	}


	get activeLinks() {
		return this.availableLinks.filter((link: any) => link.status?.toLowerCase() !== 'expired');
	}

	get displayableAvailableLinks() {
		return this.availableLinks.filter((link: any) =>
			link.status?.toLowerCase() !== 'expired' || this.isLinkAssigned(link.link_id)
		);
	}

	get hasOnlyExpiredLinks() {
		return (this.availableLinks.length > 0 && this.activeLinks.length === 0);
	}


	assignAssessment(): void {
		if (!this.selectedAssessmentId) {
			this.toastr.error('Please select an assessment');
			return;
		}
		if (!this.selectedLinkId) {
			this.toastr.error('Please select a link');
			return;
		}
		const selectedAssessment = this.availableAssessments.find(a => a.quiz_id === this.selectedAssessmentId);
		const selectedLink = this.availableLinks.find(l => l.link_id === this.selectedLinkId);

		const payload = {
			...this.jobDetails!,
			assigned_assessments: [
				{
					quiz_id: this.selectedAssessmentId,
					quiz_link_id: this.selectedLinkId,
					quiz_title: selectedAssessment?.quiz_name || '',
					quiz_link_url: selectedLink?.url || '',
					time_limit: String(selectedAssessment?.time_limit),
					status: selectedAssessment.status || '',
					mode: selectedAssessment.mode || '',
					questions_count: selectedAssessment?.questions?.length || 0
				}
			]
		};

		this.isAssignAssessment = true;
		this.subscription.add(
			this.jobService.patchJobPosting(this.jobId, this.companyId, payload).pipe(
				tap(response => {
					if (response.Success) {
						this.toastr.success('Assessment assigned successfully');
						this.showAssessmentPopup = false;
						this.getCompanyJobDetails();
					} else {
						this.toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.isAssignAssessment = false;
				}),
				catchError(() => {
					this.toastr.error('Something went wrong. Please try again');
					return of(null);
				})
			).subscribe());
	}


	copyToClipboard(text: string, id: string): void {
		if (!text) return;
		navigator.clipboard.writeText(text).then(() => {
			this.copiedId = id;
			setTimeout(() => { this.copiedId = null }, 1800);
		});
	}


	get isAssignAssessmentLinked(): boolean {
		return this.assignAssessments?.length > 0;
	}

	isAssessmentAssigned(quizId: string): boolean {
		return this.assignAssessments?.some((assign: any) => assign.quiz_id === quizId) ?? false;
	}

	getQuestionCount(quizId: string): number {
		if (this.assessments && this.assessments.length > 0) {
			const quiz = this.assessments.find(a => a.quiz_id === quizId);
			if (quiz) {
				return quiz.questions?.length || quiz.totalQuestions || 0;
			}
		}
		if (this.availableAssessments && this.availableAssessments.length > 0) {
			const quiz = this.availableAssessments.find(a => a.quiz_id === quizId);
			if (quiz) {
				return quiz.questions?.length || quiz.totalQuestions || 0;
			}
		}
		return 0;
	}


	get isAssignInterviewLinked(): boolean {
		return this.assignInterviews?.length > 0;
	}


	openConfirmDialogBox(): void {
		this.showVisibilityPopup = false;
		this.openVisibilityDialog();
	}


	getAllJobsPostings(): void {
		this.isLoadingJobs = true;
		this.subscription.add(
			this.jobService.getAllJobPosting(this.companyId, this.jobCurrentPage, this.jobLimit, 'active', '', {}).pipe(
				tap((response) => {
					if (response?.Success) {
						this.availableJobs = response.Data.jobs || [];
						this.jobTotalPages = response.Data.total_pages || 1;
					} else {
						this.toastr.error('Failed to load jobs');
					}
				}),
				catchError(() => {
					this.toastr.error('Failed to load jobs');
					return of(null);
				}),
				finalize(() => {
					this.isLoadingJobs = false;
				})
			).subscribe()
		);
	}


	getInterviewRounds(): void {
		if (!this.selectedInterviewId) return;
		this.isLoadingInterview = true;
		const params = {
			page: this.aiInterviewCurrentPage,
			limit: this.aiInterviewLimit,
			company_id: this.companyId,
			job_id: this.selectedInterviewId
		};

		this.subscription.add(
			this.aiScreeningService.getRounds(params).pipe(
				finalize(() => {
					this.isLoadingInterview = false;
				})
			).subscribe({
				next: (response: any) => {
					if (response?.Success) {
						this.availableRounds = response?.Data?.rounds || [];
						this.aiInterviewTotalPages = response?.Data?.pagination?.last_page || 1;
					} else {
						this.availableRounds = [];
					}
				},
				error: () => {
					this.availableRounds = [];
				}
			}));
	}


	assignInterview(): void {
		if (!this.selectedInterviewId) {
			this.toastr.error('Please select an interview');
			return;
		}
		if (!this.selectedRoundId) {
			this.toastr.error('Please select a rounds');
			return;
		}
		const selectedRound = this.availableRounds.find(round => round.id === this.selectedRoundId);

		const payload = {
			...this.jobDetails!,
			assigned_interviews: [
				{
					screening_round_id: selectedRound.id,
					job_role: selectedRound?.job_role,
					total_duration_minutes: String(selectedRound?.total_duration_minutes),
					status: selectedRound.status,
					interview_url: selectedRound.interview_url
				}
			]
		};

		this.isAssignInterviews = true;
		this.subscription.add(
			this.jobService.patchJobPosting(this.jobId, this.companyId, payload).pipe(
				tap(response => {
					if (response.Success) {
						this.toastr.success('Interview assigned successfully');
						this.showInterviewPopup = false;
						this.getCompanyJobDetails();
					} else {
						this.toastr.error(response.Message);
					}
				}),
				finalize(() => {
					this.isAssignInterviews = false;
				}),
				catchError(() => {
					this.toastr.error('Something went wrong. Please try again');
					return of(null);
				})
			).subscribe());
	}


	isLinkAssigned(linkId: string): boolean {
		return this.jobDetails?.assigned_assessments?.some((a: any) => a.quiz_link_id === linkId) ?? false;
	}

	isInterviewRoundAssigned(roundId: string): boolean {
		return this.assignInterviews?.some((assign: any) => assign.screening_round_id === roundId) ?? false;
	}

	get displayableAvailableRounds() {
		return this.availableRounds.filter((round: any) =>
			!this.isInterviewExpired(round) || this.isInterviewRoundAssigned(round.id)
		);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
		if (this.scrollListener) {
			window.removeEventListener('scroll', this.scrollListener, true);
		}
	}


}